<template>
    <div class="container pb-5">
        <div class="px-4 py-5 text-center text-light h-50">
            <h2 class="display-4 fw-bold">Symposium</h2>
            <div class="col-lg-6 mx-auto">
                <p class="lead mb-4">This site has been put together using <code>Laravel 11</code> and
                    <code>InertiaJS</code>. The site allows a user to have full CRUD functionality. A user can view and
                    favorite a conference as well as add a new conference.</p>
                <p>Laravel 11 | NodeJS - NPM | TailwindCSS | AlpineJS</p>
                <div class="d-grid gap-2 d-sm-flex justify-content-sm-center mb-5">
                    <button type="button" class="btn btn-outline-secondary btn-lg px-4">Symposium</button>
                    <a href="/files/symposium.apk" download="symposium.apk"><img src="../assets/img/logos/play.png"
                            alt="download android app" width="48" height="48"></a>
                </div>
            </div>
            <div class="overflow-hidden">
                <div class="container px-5">
                    <a href="https://symposium.saqibofficial.com" target="_blank"><img
                            src="../assets/img/symposiumthumbnail.png" class="img-fluid border rounded-3 shadow-lg mb-4"
                            alt="API Cental Police v2 site" width="700" height="900" loading="lazy"></a>
                </div>
            </div>
        </div>
    </div>
</template>